<template>
  <div v-if="isAppAdmin(this.$store.state.user._id)">
    <v-card-actions>
      <v-card-title>Activities</v-card-title>
      <v-spacer></v-spacer>
      <DatePicker v-model="statsDate" :past-event="true" :show-time="false"></DatePicker>
      <v-checkbox class="mr-2 ml-1" hide-details dense label="CSV" v-model="csvResults"></v-checkbox>
      <v-btn @click="getActivityStats()" color="secondary">RUN</v-btn>
    </v-card-actions>
    <v-tabs v-model="activeTab" show-arrows>
      <v-tab :key="'admin'">
        Admin Users
      </v-tab>
      <v-tab :key="'member'">
        Member Users
      </v-tab>
      <v-tab :key="'regular'">
        Regular Users
      </v-tab>
      <v-tab-item :key="'admin'">
        <v-progress-linear v-if="loading" height="20" indeterminate color="secondary"></v-progress-linear>
        <v-data-table v-else class="elevation-0" :headers="adminUsersData.headers" :loading="loading"
          :loading-text="$t('message.loading')" :items="adminUsersData.results">
          <template v-slot:top>
            <v-card-text class="text-center">
              Popultion: <b>{{ adminUsersData.population }}</b>
            </v-card-text>
          </template>
        </v-data-table>
      </v-tab-item>
      <v-tab-item :key="'member'">
        <v-progress-linear v-if="loading" height="20" indeterminate color="secondary"></v-progress-linear>
        <v-data-table v-else class="elevation-0" :headers="memberUsersData.headers" :loading="loading"
          :loading-text="$t('message.loading')" :items="memberUsersData.results">
          <template v-slot:top>
            <v-card-text class="text-center">
              Popultion: <b>{{ memberUsersData.population }}</b>
            </v-card-text>
          </template>
        </v-data-table>
      </v-tab-item>
      <v-tab-item :key="'regular'">
        <v-progress-linear v-if="loading" height="20" indeterminate color="secondary"></v-progress-linear>
        <v-data-table v-else class="elevation-0" :headers="regularUsersData.headers" :loading="loading"
          :loading-text="$t('message.loading')" :items="regularUsersData.results">
          <template v-slot:top>
            <v-card-text class="text-center">
              Popultion: <b>{{ regularUsersData.population }}</b>
            </v-card-text>
          </template>
        </v-data-table>
      </v-tab-item>
    </v-tabs>
  </div>
</template>

<script>
import BjjlinkAdminService from "@/services/BjjlinkAdminService";
import DatePicker from "@/components/inputs/DateTimePicker2.vue";

export default {
  data() {
    return {
      activities: null,
      loading: true,
      activeTab: null,
      csvResults: false,
      statsDate: new Date(),
      adminUsersData: {},
      memberUsersData: {},
      regularUsersData: {},
    };
  },
  created() {
    this.getActivityStats();
  },
  components: {
    DatePicker
  },
  methods: {
    getActivityStats() {
      this.loading = true;
      BjjlinkAdminService.activitiesStats({
        date: this.statsDate,
        csv: this.csvResults
      })
        .then((result) => {
          console.log(result);
          this.adminUsersData = result.data.adminUsers;
          this.adminUsersData.population = result.data.adminUsersCount;
          let headersAdmins = [
            {
              text: "Avtivity",
              align: "left",
              sortable: true,
              value: "activity",
            }
          ];
          Object.keys(result.data.adminUsers.days).forEach(key => {
            const val = result.data.adminUsers.days[key];
            headersAdmins.push({
              text: val,
              align: "left",
              sortable: true,
              value: val,
            },)
          });
          this.adminUsersData.headers = headersAdmins;

          //members
          this.memberUsersData = result.data.memberUsers;
          this.memberUsersData.population = result.data.memberUsersCount;
          let headersMembers = [
            {
              text: "Avtivity",
              align: "left",
              sortable: true,
              value: "activity",
            }
          ];
          Object.keys(result.data.memberUsers.days).forEach(key => {
            const val = result.data.memberUsers.days[key];
            headersMembers.push({
              text: val,
              align: "left",
              sortable: true,
              value: val,
            },)
          });
          this.memberUsersData.headers = headersMembers;

          //regular
          this.regularUsersData = result.data.regularUsers;
          this.regularUsersData.population = result.data.regularUsersCount;
          let headersRegulars = [
            {
              text: "Avtivity",
              align: "left",
              sortable: true,
              value: "activity",
            }
          ];
          Object.keys(result.data.regularUsers.days).forEach(key => {
            const val = result.data.regularUsers.days[key];
            headersRegulars.push({
              text: val,
              align: "left",
              sortable: true,
              value: val,
            },)
          });
          this.regularUsersData.headers = headersRegulars;
          this.loading = false;
          this.csvResults = false;
        });
    }
  },
};
</script>

<style scoped></style>
